import { createSlice } from '@reduxjs/toolkit'

export const V2PRMReducer = createSlice({
    name: 'v2pRmData',
    initialState: {
        V2PRMData: null,
    },
    reducers: {
        setV2PRMData: (state, action) => {
            state.V2PRMData = action.payload
        },
    },
})

// Action creators are generated for each case reducer function
export const { setV2PRMData } = V2PRMReducer.actions

export default V2PRMReducer.reducer